export const SET_TOKEN = "setToken";
export const CLEAR_TOKEN = "clearToken";
export const SET_MOVIE_POPULAR_RATED = "setMoviePopularRated"
export const SET_GENRE_LIST = "setGenreList"
export const SET_GENRE_ID_MOVIES = "setGenreIdMovies"
export const SET_MOVIE_DETAILS = "setMovieDetails"
export const SET_MOVIE_DETAIL_CAST_DIRECTOR = "setMovieDetailCastDirector"
export const SET_MOVIE = "setMovie"
export const SET_COMEDY = "setComedy"
export const SET_ACTION = "setAction"
export const SET_HORROR = "setHorror"
export const SET_THRILLER = "setThriller"
export const SET_CRIME = "setCrime"
export const SET_DRAMA = "setDrama"
export const SET_ADVENTURE = "setAdventure"
export const SET_TRAILER_VIDEOS = "setTrailerVideos"
export const SET_SEARCH_QUERY = "setSearchQuery"
export const SET_QUERY = "setQuery"
export const SET_CATEGORY_NAME = "setCategoryName"
export const SET_TV_TOP_RATED = "setTvTopRated"
export const SET_MOVIE_OR_TV = "setovieOrTv"
export const SET_WATCH_LIST = "setWatchList"
export const SET_MOVIE_INFO = "setMovieInfo"
export const SET_MOVIE_INFO_TRAILER = "setMovieInfoTrailer"
export const SET_ADD_WATCH_LIST = "setAddWatchList"